import React, { FC } from 'react';
import { Navigate } from 'react-router-dom';
import { ERoute } from 'common/const/route.enum';
import { useAppSelector } from 'app/store/store.hooks';
import { AuthCardLogo } from 'entities/Auth/components/AuthCardLogo';
import { AuthCardFooter } from 'entities/Auth/components/AuthCardFooter';
import { LoginByOtp } from 'entities/Auth/components';
import { getUserRole } from 'entities/User/User.helper';
import { selectAuth } from 'entities/Auth/Auth.slice';

export const RegistrationPage: FC = () => {
  // auth
  const auth = useAppSelector(selectAuth);

  const { isSuperAdmin } = getUserRole(auth?.access.roles);

  if (auth) {
    if (auth.access.isSelfRegistered && !auth.access.selfRegistrationCompletedAt) {
      return <Navigate to={ERoute.SelfRegistration} replace />;
    }

    return isSuperAdmin ? <Navigate to={ERoute.AccountList} replace /> : <Navigate to={ERoute.Profile} replace />;
  }

  return (
    <div className="auth-card">
      <AuthCardLogo />

      <div className="auth-card__content">
        <div className="mb-11 auth-card__content-form-title">
          Для регистрации введите номер телефона — вам придёт SMS с кодом подтверждения
        </div>

        <LoginByOtp isRegistration />

        <div className="mt-8 text-center">
          <a href={ERoute.Login} className="ff-semibold fs-xs color-dark-green text-decoration-none">
            Уже есть аккаунт? Войти
          </a>
        </div>
      </div>

      <AuthCardFooter content="СПРАУТ. Система управления закупками." />
    </div>
  );
};
